import { useTheme } from '@mui/material/styles'
import { DateTime } from 'luxon'
import {
  Area,
  Brush,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { TOTAL_KEY, USED_KEY } from '../utils/pressureGraph'
import '../vendor/recharts'

const formatTick = (timestamp) => DateTime.fromMillis(timestamp).toFormat('dd/MM')
const formatTooltipLabel = (timestamp) => DateTime.fromMillis(timestamp).toFormat('dd/MM/yyyy HH:mm ZZZZ')

const PressureChart = ({ points, height, brushIndexes, compact = false }) => {
  const theme = useTheme()

  return (
    <ResponsiveContainer width="100%" height={height}>
      <ComposedChart
        data={points}
        margin={compact ? { top: 5, right: 10, left: -20, bottom: 0 } : { top: 20, right: 30, left: 0, bottom: 5 }}
      >
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <XAxis
          dataKey="timestamp"
          type="number"
          scale="time"
          domain={['dataMin', 'dataMax']}
          minTickGap={40}
          tickFormatter={formatTick}
          tick={{ fill: theme.palette.text.primary, fontSize: compact ? 11 : undefined }}
        />
        <YAxis
          domain={[0, (dataMax) => dataMax + 1]}
          allowDecimals={false}
          axisLine={false}
          tickLine={false}
          tick={{ fill: theme.palette.text.primary, fontSize: compact ? 11 : undefined }}
        />
        <Tooltip
          labelFormatter={formatTooltipLabel}
          labelStyle={{ color: theme.palette.text.primary }}
          contentStyle={{
            backgroundColor: theme.palette.background.paper,
            borderRadius: theme.shape.borderRadius,
          }}
        />
        <Legend {...(compact ? { verticalAlign: 'top', height: 24, iconSize: 10 } : {})} />
        <Area
          type="stepAfter"
          dataKey={USED_KEY}
          stroke={theme.palette.secondary.main}
          fill={theme.palette.secondary.main}
          fillOpacity={0.4}
          strokeWidth={2}
          isAnimationActive={false}
        />
        <Line
          type="stepAfter"
          dataKey={TOTAL_KEY}
          stroke={theme.palette.primary.main}
          strokeWidth={2}
          dot={false}
          isAnimationActive={false}
        />
        <ReferenceLine
          x={Date.now()}
          stroke={theme.palette.error.main}
          label={compact ? undefined : { value: 'Now', position: 'insideTopRight', fill: theme.palette.error.main }}
        />
        {brushIndexes && (
          <Brush
            dataKey="timestamp"
            height={30}
            stroke={theme.palette.primary.main}
            tickFormatter={formatTick}
            {...brushIndexes}
          />
        )}
      </ComposedChart>
    </ResponsiveContainer>
  )
}

export default PressureChart
